import { useDataModel } from '@thd-nucleus/data-sources';
import { shouldSuppressBanner } from '../utils/helpers';
import { getApiParams } from '../utils/queryParamsHelpers';

const useSponsoredBannerApi = ({
  guestUserID,
  experienceContext,
  pageContext,
  schema,
  bannerType,
  mcvisID,
  shouldSuppress,
  isLeaderboardEnabled,
  matchProducts,
  anchorSku,
  mounted,
  nValue
}) => {
  const {
    pageType,
    channel,
    customerType,
    category,
    keyword,
    customerIdentifier,
    forceAd
  } = getApiParams({
    guestUserID, experienceContext, pageContext, schema
  });
  const { data, loading, error } = useDataModel('sponsored', {
    skip: !mounted || shouldSuppress || (bannerType === 'leaderboard' && !isLeaderboardEnabled),
    ssr: false,
    variables: {
      nValue,
      bannerType,
      marketingId: mcvisID,
      pageType,
      category,
      customerType,
      channel,
      customerIdentifier,
      anchorSku,
      forceAd,
      keyword,
      matchProducts
    }
  });
  return { data, loading, error };

};

export default useSponsoredBannerApi;
